/**
 * GLE-8144: who a booking is recorded against.
 *
 * The detected AE is read off the calendar event we just found, so it reflects
 * who actually owns the meeting - including after a round-robin assignment or a
 * reschedule onto a different AE. The assigned AE is what the account already
 * had, which on a reschedule is by definition the previous owner.
 *
 * Detection therefore wins, and the assigned AE is only the fallback for when
 * detection returned nothing. This used to be the other way around: every
 * reschedule reported the previous AE, and both the customer dashboard and the
 * post-meeting survey routing follow that field.
 */
export const resolveBookingAEId = ({
  detectedAEId,
  assignedAEId,
}: {
  detectedAEId?: string | null;
  assignedAEId?: string | null;
}): string | undefined => {
  if (detectedAEId) {
    return detectedAEId;
  }

  if (assignedAEId) {
    return assignedAEId;
  }

  return undefined;
};
